import React from 'react';
import { makeStyles } from '@material-ui/core';
import colors from '../../../theme/colors';

export type SonarPulseProps = {
  maxWidth?: number;
  pulseBaseColor?: string;
};

type StyleProps = {
  maxWidth: number;
  pulseBaseColor: string;
};

const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    width: (props: StyleProps): number => props.maxWidth,
    height: (props: StyleProps): number => props.maxWidth,
  },
  circle: {
    borderRadius: '50%',
    position: 'absolute',
    width: (props: StyleProps): number => props.maxWidth,
    height: (props: StyleProps): number => props.maxWidth,
    backgroundColor: (props: StyleProps): string => props.pulseBaseColor,
    opacity: 0,
    animation: '$scaleIn 2s infinite cubic-bezier(.36, .11, .5, .32)',
  },
  '@keyframes scaleIn': {
    from: {
      transform: 'scale(.1, .1)',
      opacity: 0.7,
    },
    to: {
      transform: 'scale(1.0, 1.0)',
      opacity: 0,
    },
  },
});

const SonarPulse = ({
  maxWidth = 54,
  pulseBaseColor = colors.bright_turquoise,
}: SonarPulseProps): JSX.Element => {
  const classes = useStyles({ maxWidth, pulseBaseColor });
  return (
    <div className={classes.wrapper}>
      <div className={classes.circle} style={{ animationDelay: '-1.5s' }} />
      <div className={classes.circle} style={{ animationDelay: '-1.0s' }} />
      <div className={classes.circle} style={{ animationDelay: '-0.5s' }} />
      <div className={classes.circle} style={{ animationDelay: '0s' }} />
    </div>
  );
};

export default SonarPulse;
